<template>
  <div class="ui-base-panel-wrapper" :id="id">
    <div class="title-wrapper">
      <img v-if="titleIcon" :src="titleIcon" class="img-title" />
      <span class="title">{{ title }}</span>
    </div>
    <div class="header-wrapper">
      <div class="action-wrapper" @click="handleClickMore" v-if="showAction">
        <span class="action-label">{{ actionLabel }}</span>
        <i class="icon icon-arrow-right"></i>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "uiBasePanel",
  props: {
    titleIcon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    showAction: {
      type: Boolean,
      default: true
    },
    actionLabel: {
      type: String,
      default: "更多"
    },
    id: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleClickMore() {
      this.$emit("clickMore")
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-base-panel-wrapper {
  background: #ffffff;
  border-radius: 0.2rem;
  position: relative;
  padding: 0 0.3rem;
  margin-top: 0.9rem;
  .title-wrapper {
    position: absolute;
    top: -0.3rem;
    left: 0;
    height: 0.8rem;
    width: auto;
    .img-title {
      height: 100%;
      display: block;
    }
    .title {
      color: #ffffff;
      font-size: 0.3rem;
      font-weight: bold;
      text-align: center;
      display: inline-block;
      width: 1.5rem;
      position: absolute;
      top: 50%;
      left: 0.35rem;
      transform: translate3d(0, -50%, 0);
    }
  }
  .header-wrapper {
    display: flex;
    flex-direction: row-reverse;
    border-bottom: 0.5px solid #eeeeee;
    margin-bottom: 0.1rem;
    height: 0.72rem;
    .action-wrapper {
      display: inline-flex;
      padding: 0.17rem 0 0.16rem;
      line-height: 0.37rem;
      align-items: center;
      font-family: PingFangSC-Regular;
      font-size: 0.26rem;
      letter-spacing: 0;
      text-align: right;
      color: #555555;
      cursor: pointer;
      &:active {
        opacity: 0.7;
      }
      .action-label {
        margin-right: 0.07rem;
      }
      .icon-arrow-right {
        width: 0.2rem;
        height: 0.2rem;
        background: url("../../assets/images/arrow.png") no-repeat right center;
        background-size: auto 100%;
      }
    }
  }
}
.ui-base-panel-wrapper.pc {
  border-radius: 20px;
  padding: 0 30px;
  margin-top: 64px;
  .title-wrapper {
    top: -30px;
    height: 70px;
    .title {
      font-size: 18px;
      width: 120px;
      left: 35px;
    }
  }
  .header-wrapper {
    margin-bottom: 10px;
    height: 55px;
    .action-wrapper {
      padding: 17px 0;
      line-height: 22px;
      font-size: 16px;
      min-height: 22px;
      .action-label {
        margin-right: 7px;
      }
      .icon-arrow-right {
        width: 17px;
        height: 17px;
        background: url("../../assets/images/arrow.png") no-repeat right center;
        background-size: auto 100%;
      }
    }
  }
}
</style>
